const imageUploadStyle = {
  containerFullWidth: {
    alignItems: 'initial',
  },
  thumbnail: {
    display: 'inline-block',
    marginBottom: '10px',
    overflow: 'hidden',
    textAlign: 'center',
    verticalAlign: 'middle',
    maxWidth: '250px',
    boxWhadow:
      '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
  },
  imgCircle: {
    width: '100px',
    borderRadius: '50%',
  },
  thumbnailImg: {
    maxHeight: '100%',
    width: '100%',
    height: 'auto',
    marginRight: 'auto',
    marginLeft: 'auto',
    display: 'block',
    maxWidth: '100%',
  },
  addButtonWrapper: {
    position: 'relative',
    overflow: 'hidden',
    display: 'inline-block',
    margin: '10px 1px',
    '&:hover': {
      boxShadow:
        '0 14px 26px -12px rgba(91, 196, 186, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(91, 196, 186, 0.2)',
    },
  },
  addButton: {
    margin: 0,
    padding: '16px',
  },
  input: {
    fontSize: 0,
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  deleteButton: {
    marginLeft: 10,
    padding: '10px 16px',
  },
};

export default imageUploadStyle;
